import React, { useEffect } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import './Confirmation.css';
import { formatStoreInfo, formatStoreHours } from '../../utils/helpers';
import moment from 'moment';

class Confirmation extends React.Component {
    
    constructor(props) {
      super(props);

      this.state = {
      };
  }

    getStoreInfo = () => {
        const { userInfo } = this.props;
        return formatStoreInfo(userInfo.selectedStore);
    }

    getStoreHours = () => {
        const { userInfo } = this.props;
        return formatStoreHours(userInfo.selectedStore);
    }

    itemsList = (items) => {
        return items.map((item, i) => {
                return (
                    <div key={`item-${i}`} className="row confirmation-container_gear">
                        <span className="confirmation-container_gear_item-info_bold">{item.brand ? item.brand : ""} {item.model ? item.model : ""}</span>
                        <span className="confirmation-container_gear_item-info">{item.condition ? item.condition : ""} {item.year ? item.year : ""} {item.color ? item.color : ""} {item.serialNumber ? `Serial #${item.serialNumber},` : ""} 
                        {item.askingMinPrice ? `$${item.askingMinPrice}` : ""} {item.askingMaxPrice ? ` - $${item.askingMaxPrice}` : ""}</span>
                    </div>
                );
            })
    }

    getUserInfo = (userInfo) => {
       return (
            <div >
                <p className="confirmation-container_name">{userInfo.name}</p>
                <p className="confirmation-container_email">{userInfo.email}</p>
            </div>
        ); 
    }
    changeAppointment = (id) => {
        this.props.getCustomerInfo(id);
    }

    getAppointmentInfo = (userInfo) => {       
        const formattedDate = moment(userInfo.scheduledDate).format("dddd, MMM D");
        const formattedTime = userInfo.scheduledTime;
        const selectedStore = userInfo.selectedStore.city;
        const { confirmationId } = this.props;
        const formattedAddress = `${userInfo.selectedStore.address}, ${userInfo.selectedStore.state}, ${userInfo.selectedStore.zip}`;
        let timeFrame = formattedTime;
        if (formattedTime === 'Morning') {
            timeFrame = ' before 12 p.m.';
        } else if (formattedTime === "Afternoon") {
            timeFrame = " between 12 p.m. and 5 p.m."
        } else if (formattedTime === 'Evening') {
            timeFrame = " after 5 p.m.";
        }

        return (
            <div className="confirmation-container">
                <h2>You’re all set!</h2>
                <p>We'll see you on {formattedDate}, {timeFrame}, at Guitar Center {selectedStore}.</p>
                <a id="get-directions-btn" href={`http://maps.google.com/?q=${formattedAddress}`} className="btn btn-primary confirmation-container_btn" target="_blank">Get Directions</a>
                <h2> What's Next?</h2>
                <p>1. Bring your gear in to the store on the day of your appointment.</p>
                <p>2. We’ll assess your item(s) based on condition, brand, recent sales and our current stock levels. </p>
                <p>3. If we come to an offer you accept, you’ll get paid same-day, or you can trade it in for a discount on new gear.</p>
                <p>You could be done in as little as 30–45 minutes, depending on the number of items you’re selling.</p>
                {/* <button onClick={()=>this.changeAppointment(confirmationId)} className="btn btn-primary confirmation-container_btn">Reschedule</button> */}
            </div>
        )
    }

    getEstimateView = (userInfo) => {
        return (
            <div className="confirmation-container">
                <a href="#" onClick={this.props.handleClose} className="exit-btn"></a>
                <h2>We'll be in touch soon.</h2>
                <h2> What's Next?</h2>
                <p>1. Bring your gear in to the store on the day of your appointment.</p>
                <p>2. We’ll assess your item(s) based on condition, brand, recent sales and our current stock levels. </p>
                <p>3. If we come to an offer you accept, you’ll get paid same-day, or you can trade it in for a discount on new gear.</p>
                <p>You could be done in as little as 30–45 minutes, depending on the number of items you’re selling.</p>
            </div>
        )
    }

    render() {
        const { items, confirmationId, userInfo, sellerOption } = this.props;

        if (sellerOption === 'OPTION-B') {
            return (
                <div className="main-container">
                    <a href="#" onClick={this.props.handleClose} className="exit-btn"></a>
                    {this.getEstimateView(userInfo)}                
                </div>     
            )
        } else {
            return (
                <div className="main-container">
                    <a href="#" onClick={this.props.handleClose} className="exit-btn"></a>
                    {this.getAppointmentInfo(userInfo)}
                </div>
            )
        }

        return ( 
        <div className="confirmation-container"> 
            <h1 className="confirmation_header">What's Next?</h1>
            {/* <p>ID#: {confirmationId}</p> */}
            <p>Thanks for choosing to sell or trade in your gear with Guitar Center. We’ll have one of our associates get in touch with you to chat more about your gear and schedule an in-store evaluation. You should have an email confirmation in your inbox soon, or you can print this page for your records. As a note, the asking price you provided helps us evaluate your gear, but until a full appraisal is complete, we cannot commit to any purchase or amount.</p>
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                    <h4>Preferred store location:</h4>
                        <div className="row">
                            <div className="confirmation-container_store-info col-md-6 col-sm-6 col-xs-12">
                                {this.getStoreInfo()}
                            </div>
                            <div className="confirmation-container_store-hours col-md-6 col-sm-6 col-xs-12">
                            {this.getStoreHours()}
                            </div>
                        </div>
                    </div>
                    <div className="confirmation-container_your-info col-md-5">
                        <h4>Your info:</h4>
                        {this.getUserInfo(userInfo)}
                    </div>
                </div>
                <div className="row">
                    <div className="confirmation-container_your-gear col-md-12">
                        <h4>Your gear:</h4>
                        {this.itemsList(items)}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
  export default Confirmation;